// #region debug-point C:init
window.__traeDbgPdpBlipClicks =
  window.__traeDbgPdpBlipClicks ||
  ((hypothesisId, msg, data) => {
    try {
      const payload = {
        sessionId: 'pdp-blip-clicks',
        runId: 'pre',
        hypothesisId,
        location: 'thumbnail-carousel.js',
        msg: `[DEBUG] ${msg}`,
        data: data || {},
        ts: Date.now()
      };
      const url = 'http://127.0.0.1:7777/event';
      const body = JSON.stringify(payload);
      if (navigator?.sendBeacon) {
        const blob = new Blob([body], { type: 'text/plain' });
        navigator.sendBeacon(url, blob);
        return;
      }
      fetch(url, { method: 'POST', mode: 'no-cors', body }).catch(() => {});
    } catch (e) {}
  });
// #endregion

class ThumbnailCarousel {
  constructor(container, options) {
    options = options || {};
    this.container = container;
    this.track = container.querySelector('.thumbnail-carousel__track');
    this.slidesToShow = options.slidesToShow || 5;
    this.onChange = options.onChange || null;
    this.activeIndex = this._parseActiveIndex(container.dataset.activeThumb) || 0;
    this.items = [];

    this.itemWidth = 0;
    this.gap = 0;
    this.viewportWidth = 0;
    this.maxTranslate = 0;
    this.currentTranslate = 0;

    this._dragging = false;
    this._dragStartX = 0;
    this._dragStartTranslate = 0;
    this._didDrag = false;
    this._capturedPointer = null;
    this._observer = null;
    this._eventsBound = false;

    this._onDown = this._onDown.bind(this);
    this._onMove = this._onMove.bind(this);
    this._onUp = this._onUp.bind(this);
    this._onClick = this._onClick.bind(this);
    this._onTransitionEnd = this._onTransitionEnd.bind(this);

    this._init();
  }

  setActiveMediaIds(mediaIds) {
    var list = Array.isArray(mediaIds) ? mediaIds.slice() : [];
    var indices = [];
    for (var i = 0; i < list.length; i++) {
      var id = (list[i] ?? '').toString();
      if (!id) continue;
      var idx = this.items.findIndex(el => (el?.dataset?.mediaId || '') === id);
      if (idx < 0) continue;
      if (indices.indexOf(idx) === -1) indices.push(idx);
    }
    this.setActiveIndices(indices);
  }

  setActiveIndices(indices) {
    var list = Array.isArray(indices) ? indices.slice() : [];
    var uniq = [];
    for (var i = 0; i < list.length; i++) {
      var n = parseInt(list[i], 10);
      if (Number.isNaN(n)) continue;
      if (n < 0 || n >= this.items.length) continue;
      if (uniq.indexOf(n) === -1) uniq.push(n);
    }
    if (!uniq.length) return;
    this.activeIndex = uniq[0];
    this._applyActiveIndices(uniq);
  }

  _applyActiveIndices(indices) {
    if (!this.items || !this.items.length) return;
    for (var i = 0; i < this.items.length; i++) {
      this.items[i].classList.remove('swiper-slide-thumb-active');
    }
    for (var j = 0; j < indices.length; j++) {
      var idx = indices[j];
      if (this.items[idx]) {
        this.items[idx].classList.add('swiper-slide-thumb-active');
      }
    }
  }

  _init() {
    var self = this;
    requestAnimationFrame(function() {
      self.items = Array.from(self.track.querySelectorAll('.swiper-slide'));
      if (!self.items.length) return;
      self._calculateDimensions();
      self._bindEvents();
      self._startObserver();
      self.goTo(self.activeIndex, false, true);
      self._updateVisibility();
    });
  }

  refresh() {
    if (this._observer) { this._observer.disconnect(); }
    var self = this;
    requestAnimationFrame(function() {
      self.items = Array.from(self.track.querySelectorAll('.swiper-slide'));
      if (!self.items.length) return;
      if (self.activeIndex >= self.items.length) {
        self.activeIndex = Math.max(0, self.items.length - 1);
      }
      self._calculateDimensions();
      self.goTo(self.activeIndex, false, true);
      self._startObserver();
      self._updateVisibility();
    });
  }

  destroy() {
    this._unbindEvents();
    this._releaseCapture();
    if (this._observer) { this._observer.disconnect(); }
  }

  goTo(index, animate, centerThumbnail) {
    if (!this.items.length) return;
    this.activeIndex = Math.max(0, Math.min(index, this.items.length - 1));
    
    // Only move the carousel track if specifically requested
    if (centerThumbnail === true) {
      var step = this.itemWidth + this.gap;
      var halfViewport = this.viewportWidth / 2;
      var target = (this.activeIndex * step) + (this.itemWidth / 2) - halfViewport;
      
      var totalWidth = this.itemWidth * this.items.length + this.gap * (this.items.length - 1);
      
      if (totalWidth <= this.viewportWidth) {
        this.currentTranslate = 0;
      } else {
        this.currentTranslate = Math.max(0, Math.min(target, this.maxTranslate));
      }
      if (animate !== false) {
        this._animateTo(this.currentTranslate);
      } else {
        this._setTranslate(this.currentTranslate);
      }
    }
    
    this._setActiveItem(this.activeIndex);
  }

  snapToClosest(velocity) {
    if (!this.items.length) return;
    var target = this.currentTranslate;
    var step = this.itemWidth + this.gap;
    if (Math.abs(velocity) > 0.2) {
      target += (velocity > 0 ? -1 : 1) * step;
      target = Math.max(0, Math.min(target, this.maxTranslate));
    }
    this.goTo(Math.round(target / step), true, true);
  }

  getActiveMediaId() {
    return this.items[this.activeIndex] ? this.items[this.activeIndex].dataset.mediaId : null;
  }

  getActiveIndex() {
    return this.activeIndex;
  }

  syncToIndex(index) {
    if (index >= 0 && index < this.items.length) {
      this.activeIndex = Math.max(0, Math.min(index, this.items.length - 1));
      this._setActiveItem(this.activeIndex);
      
      // Calculate the boundaries of the active thumbnail
      var itemStart = index * (this.itemWidth + this.gap);
      var itemEnd = itemStart + this.itemWidth;
      
      // Determine what part of the track is currently visible
      var visibleStart = this.currentTranslate;
      var visibleEnd = this.currentTranslate + this.viewportWidth;
      
      // If the active thumbnail is out of bounds to the left, slide left
      if (itemStart < visibleStart) {
        this.currentTranslate = Math.max(0, itemStart);
        this._animateTo(this.currentTranslate);
      } 
      // If the active thumbnail is out of bounds to the right, slide right
      else if (itemEnd > visibleEnd) {
        this.currentTranslate = Math.min(this.maxTranslate, itemEnd - this.viewportWidth);
        this._animateTo(this.currentTranslate);
      }
    }
  }

  _parseActiveIndex(value) {
    if (value === undefined || value === null || value === '') return null;
    var n = parseInt(value, 10);
    return Number.isNaN(n) ? null : n;
  }

  _calculateDimensions() {
    if (!this.items.length) return;
    var cs = getComputedStyle(this.track);
    var gv = parseInt(cs.columnGap || cs.gap || '0', 10);
    this.gap = Number.isNaN(gv) ? 0 : gv;
    
    // We want the viewport to fill the container width completely
    this.container.style.maxWidth = '100%';
    
    // Read the actual computed viewport width after allowing it to fill 100%
    this.viewportWidth = this.container.clientWidth;


    if (
      window.innerWidth < 750 &&
      typeof this.slidesToShow === 'number' &&
      this.slidesToShow > 0 &&
      this.viewportWidth > 0
    ) {
      var desired =
        (this.viewportWidth - this.gap * (this.slidesToShow - 1)) /
        this.slidesToShow;
      if (desired > 0) {
        var desiredPx = desired.toFixed(3) + 'px';
        this.container.style.setProperty('--product-thumbs-size', desiredPx);
        this.itemWidth = desired;
      }
    }

    if (!this.itemWidth) {
      this.itemWidth = this.items[0] ? this.items[0].offsetWidth : 72;
      if (this.itemWidth === 0) {
        this.itemWidth = 60;
      }
    }
    
    var totalWidth = this.itemWidth * this.items.length + this.gap * (this.items.length - 1);
    
    // Strict calculation to prevent scrolling past the last item
    this.maxTranslate = Math.max(0, totalWidth - this.viewportWidth);
  }

  _setTranslate(value) {
    this.track.style.transition = 'none';
    this.track.style.transform = 'translate3d(' + (-value) + 'px, 0, 0)';
  }

  _animateTo(value) {
    this.track.style.transition = 'transform 0.3s ease';
    this.track.style.transform = 'translate3d(' + (-value) + 'px,0,0)';
  }

  _onTransitionEnd(e) {
    if (e.target === this.track && e.propertyName === 'transform') {
      this.track.style.transition = 'none';
    }
  }

  _setActiveItem(index) {
    if (!this.items || !this.items.length) return;
    
    // The active index logic needs to know if the main swiper shows 2 slides at a time.
    // In product-media.js, desktop usually shows 2 slides, so there are actually 2 active items.
    
    var activeIndices = [index];
    if (window.innerWidth >= 750) {
      var loopEnabled = this.container && this.container.dataset && this.container.dataset.loop === 'true';
      var nextIndex = index + 1;
      if (nextIndex < this.items.length) {
        activeIndices.push(nextIndex);
      } else if (loopEnabled && this.items[0]) {
        activeIndices.push(0);
      }
    }
    this._applyActiveIndices(activeIndices);

    // #region debug-point B:thumb-active-state
    try {
      var loopEnabled2 = this.container && this.container.dataset && this.container.dataset.loop === 'true';
      var nextIndex2 = index + 1;
      var nextAppliedIndex =
        window.innerWidth >= 750
          ? (nextIndex2 < this.items.length ? nextIndex2 : loopEnabled2 ? 0 : null)
          : null;
      window.__traeDbgPdpBlipClicks?.('B', 'thumb:setActive', {
        index,
        nextIndex: nextAppliedIndex,
        items: this.items.length,
        loopEnabled: loopEnabled2,
        indexMediaId: this.items[index]?.dataset?.mediaId || null,
        nextMediaId:
          typeof nextAppliedIndex === 'number'
            ? this.items[nextAppliedIndex]?.dataset?.mediaId || null
            : null
      });
    } catch (e) {}
    // #endregion
  }

  _bindEvents() {
    if (this._eventsBound) return;
    this._eventsBound = true;
    this.container.addEventListener('pointerdown', this._onDown);
    this.container.addEventListener('pointermove', this._onMove);
    this.container.addEventListener('pointerup', this._onUp);
    this.container.addEventListener('pointercancel', this._onUp);
    this.container.addEventListener('pointerleave', this._onUp);
    this.container.addEventListener('click', this._onClick);
    this.track.addEventListener('transitionend', this._onTransitionEnd);
  }

  _unbindEvents() {
    if (!this._eventsBound) return;
    this._eventsBound = false;
    this.container.removeEventListener('pointerdown', this._onDown);
    this.container.removeEventListener('pointermove', this._onMove);
    this.container.removeEventListener('pointerup', this._onUp);
    this.container.removeEventListener('pointercancel', this._onUp);
    this.container.removeEventListener('pointerleave', this._onUp);
    this.container.removeEventListener('click', this._onClick);
    this.track.removeEventListener('transitionend', this._onTransitionEnd);
    this._releaseCapture();
  }

  _releaseCapture() {
    if (this._capturedPointer !== null) {
      try { this.container.releasePointerCapture(this._capturedPointer); } catch (e) {}
      this._capturedPointer = null;
    }
    if (this._dragging) {
      this._dragging = false;
      this.container.classList.remove('thumbnail-carousel--dragging');
    }
  }

  _onDown(e) {
    if (e.button !== undefined && e.button !== 0) return;
    
    // Completely remove the e.isPrimary check as it breaks on many devices
    // if (e.pointerType === 'mouse' && !e.isPrimary) return;

    this._capturedPointer = e.pointerId;
    try { this.container.setPointerCapture(e.pointerId); } catch(e) {}
    this._didDrag = false;
    this._dragging = true;
    this._clickTarget = e.target;

    this._dragStartX = e.clientX;
    this._dragStartTranslate = this.currentTranslate;
    this.track.style.transition = 'none';
    this.container.classList.add('thumbnail-carousel--dragging');
    // #region debug-point C:thumb-down
    window.__traeDbgPdpBlipClicks?.('C', 'thumb:down', {
      pointerId: e.pointerId,
      pointerType: e.pointerType,
      capturedPointer: this._capturedPointer,
      activeIndex: this.activeIndex,
      items: this.items.length
    });
    // #endregion
  }

  _onMove(e) {
    if (!this._dragging) return;
    if (e.pointerId !== this._capturedPointer) return;

    var dx = e.clientX - this._dragStartX;
    
    if (Math.abs(dx) > 3) this._didDrag = true;

    var nt = this._dragStartTranslate - dx;
    var ratio = 0.12;
    if (nt < 0) {
      nt = nt * ratio;
    } else if (nt > this.maxTranslate) {
      nt = this.maxTranslate + (nt - this.maxTranslate) * ratio;
    }
    this.currentTranslate = nt;
    this.track.style.transform = 'translate3d(' + (-nt) + 'px, 0, 0)';
  }

  _onUp(e) {
    if (e.pointerId !== this._capturedPointer) return;

    var dx = e.clientX - this._dragStartX;
    var absD = Math.abs(dx);
    this._releaseCapture();

    this.currentTranslate = Math.max(0, Math.min(this.currentTranslate, this.maxTranslate));

    if (absD < 3) {
      this._animateTo(this.currentTranslate);
      return;
    }

    // Rather than snapping to the closest slide, just bounce back from the edges
    this._animateTo(this.currentTranslate);
    // #region debug-point C:thumb-up
    window.__traeDbgPdpBlipClicks?.('C', 'thumb:up', {
      pointerId: e.pointerId,
      didDrag: this._didDrag,
      activeIndex: this.activeIndex,
      currentTranslate: this.currentTranslate,
      maxTranslate: this.maxTranslate
    });
    // #endregion
  }

  _onClick(e) {
    // #region debug-point C:thumb-click
    window.__traeDbgPdpBlipClicks?.('C', 'thumb:click', {
      didDrag: this._didDrag,
      capturedPointer: this._capturedPointer,
      targetTag: e.target?.tagName || null,
      targetMediaId: e.target?.closest?.('.swiper-slide')?.dataset?.mediaId || null,
      activeIndex: this.activeIndex
    });
    // #endregion
    if (this._didDrag) {
      e.preventDefault();
      e.stopPropagation();
      this._clickTarget = null;
      return;
    }
    var target = this._clickTarget || e.target;
    var item = target.closest('.swiper-slide');
    this._clickTarget = null;
    if (!item) return;
    var index = this.items.indexOf(item);
    if (index === -1 || index === this.activeIndex) return;
    e.preventDefault();
    e.stopPropagation();
    this.goTo(index, true, true);
    if (typeof this.onChange === 'function') {
      this.onChange(index, item);
    }
  }


  _updateVisibility() {
    var totalWidth = this.itemWidth * this.items.length + this.gap * (this.items.length - 1);
    var hasO = totalWidth > this.viewportWidth;
    this.container.classList.toggle('thumbnail-carousel--has-overflow', hasO);
    this.container.classList.toggle('thumbnail-carousel--single-row', !hasO);
  }

  _startObserver() {
    if (this._observer) this._observer.disconnect();
    var self = this;
    var pending = false;
    this._observer = new MutationObserver(function(mutations) {
      var relevant = false;
      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];
        if (m.type === 'childList' && (m.addedNodes.length || m.removedNodes.length)) {
          relevant = true;
          break;
        }
      }
      if (relevant && !pending) {
        pending = true;
        requestAnimationFrame(function() {
          pending = false;
          self.refresh();
        });
      }
    });
    this._observer.observe(this.track, { childList: true });
  }
}

window.ThumbnailCarousel = ThumbnailCarousel;
